import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    submit: 'Continue',
    title: "Define {firstName} {lastName}'s new role",
  },
  fr: {
    submit: 'Continuer',
    title: 'Définissez le nouveau rôle de {firstName} {lastName}',
  },
} as const);

export default locales;
